import { useLayoutEffect } from "react";

// Safari's keyboard can resize only the visual viewport, leaving 100dvh and
// fixed panels behind it. Keep the room and thread inside the visible area.
export function usePhoneViewport() {
  useLayoutEffect(() => {
    const viewport = window.visualViewport;
    const root = document.documentElement;
    const update = () => {
      if (viewport && viewport.scale !== 1) return; // Preserve pinch zoom.
      root.style.setProperty("--phone-height", `${viewport?.height ?? window.innerHeight}px`);
      root.style.setProperty("--phone-top", `${viewport?.offsetTop ?? 0}px`);
      root.classList.toggle("phone-keyboard-open", !!viewport && window.innerHeight - viewport.height > 120);
    };
    update();
    viewport?.addEventListener("resize", update);
    viewport?.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    return () => {
      viewport?.removeEventListener("resize", update);
      viewport?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      root.style.removeProperty("--phone-height");
      root.style.removeProperty("--phone-top");
      root.classList.remove("phone-keyboard-open");
    };
  }, []);
}
